import { supabase } from '../lib/supabase'
import { logUpdate } from './userLogs'
import type { MarketingParameter } from '../types/marketingParameters'

export const marketingParametersService = {
  async listParameters(): Promise<MarketingParameter[]> {
    const { data, error } = await supabase
      .from('marketing_parameters')
      .select('*')
      .order('key', { ascending: true })

    if (error) throw error
    return (data || []) as MarketingParameter[]
  },

  async getValueByKey(key: string): Promise<string | null> {
    const { data, error } = await supabase
      .from('marketing_parameters')
      .select('value')
      .eq('key', key)
      .maybeSingle()

    if (error) {
      console.warn('[marketingParametersService] getValueByKey error:', error)
      return null
    }
    return data?.value ?? null
  },

  async updateParameter(
    id: string,
    payload: { value: string; description?: string }
  ): Promise<MarketingParameter> {
    const { data: existing } = await supabase
      .from('marketing_parameters')
      .select('*')
      .eq('id', id)
      .maybeSingle()
    const previous = existing as MarketingParameter | null

    const update: { value: string; description?: string } = { value: payload.value }
    if (payload.description !== undefined) update.description = payload.description

    const { data, error } = await supabase
      .from('marketing_parameters')
      .update(update)
      .eq('id', id)
      .select('*')
      .single()

    if (error) throw error
    const row = data as MarketingParameter

    void logUpdate(
      'parameter',
      row.id,
      `Marketing: parâmetro "${row.key}" atualizado`,
      { value: previous?.value ?? null },
      { value: row.value }
    )

    return row
  },

  async listDepartmentsActive(): Promise<{ id: string; name: string; display_name: string }[]> {
    const { data, error } = await supabase
      .from('departments')
      .select('id, name, display_name')
      .eq('is_active', true)
      .order('display_name', { ascending: true })

    if (error) throw error
    return (data || []) as { id: string; name: string; display_name: string }[]
  },
}
